const routes = {
  LOGIN: 'login',
  MAIN: {
    PROJECTS: "",
    PLANNING: "planning",
    PROFILE: "profile",
    SELECTIONS: "selections",
    ADMIN: "admin",
    FEEDBACK: "feedback",
  }
};

export default routes;
